import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const MainContainer = styled(Box)({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  marginTop      : '100px',
});

export const LogoContainer = styled(Box)(({ theme }) => ({
  display      : 'flex',
  background   : theme.palette.primary.gray3,
  width        : '68px',
  height       : '68px',
  borderRadius : '50%',
}));

export const TextContainer = styled(Box)({
  display        : 'flex',
  flexDirection  : 'column',
  maxWidth       : '500px',
  justifyContent : 'center',
  padding        : '20px 0px 0px 10px',
});

export const SkeletonContainer = styled(Box)({
  display       : 'flex',
  flexDirection : 'column',
  alignItems    : 'center',
});
